module.exports = __webpack_public_path__ + "img/flag-IR.f758ca5b.svg";